var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.47,
    height: 10,
    viewBox: "0 0 15.47 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_184875",
    "data-name": "Group 184875",
    transform: "translate(-222 -3678)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1835",
    "data-name": "Ellipse 1835",
    cx: 2.491,
    cy: 2.491,
    rx: 2.491,
    ry: 2.491,
    transform: "translate(227.244 3680.51)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49847",
    "data-name": "Path 49847",
    d: "M15.233,96.208c-1.831-2.212-4.6-4.342-7.5-4.342S2.067,94,.238,96.208a1.035,1.035,0,0,0,0,1.319,15.5,15.5,0,0,0,2.712,2.566c3.243,2.361,6.321,2.366,9.571,0a15.5,15.5,0,0,0,2.712-2.566A1.036,1.036,0,0,0,15.233,96.208Zm-7.5-2.675A3.334,3.334,0,1,1,4.4,96.867,3.338,3.338,0,0,1,7.735,93.533Z",
    transform: "translate(222 3586.134)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewicon);
export default __webpack_public_path__ + "static/media/viewicon.d58e9a1ea995a847d02843b3e8175e3b.svg";
export { ForwardRef as ReactComponent };